<div class="modal-header">
    @if (provisioningState() === 'Pending') {
        <h4 class="modal-title">Creating connection</h4>
    } @else if (provisioningState() === 'Failed') {
        <h4 class="modal-title">Connection creation failed</h4>
    } @else {
        <h4 class="modal-title">Connection created</h4>
    }
</div>
<div class="modal-body connection-result-modal" role="status" aria-live="polite">
    @if (provisioningState() === 'Pending') {
        <div class="state-panel state-panel-pending text-center">
            <mat-progress-spinner mode="indeterminate" diameter="44" aria-label="Connection provisioning in progress">
            </mat-progress-spinner>
            <h5 class="state-title">Provisioning your connection</h5>
            <p class="state-description">
                This usually takes 30 to 60 seconds. You can safely close this window while provisioning continues.
            </p>
            <p class="state-detail">You can check the connection status anytime from the Connections list.</p>
            <p class="state-metric"><strong>Elapsed:</strong> {{ provisioningElapsedTime() }}</p>
        </div>
    } @else if (provisioningState() === 'Failed') {
        <div class="state-panel state-panel-failed">
            <mat-icon class="state-icon" aria-label="Connection provisioning failed">error</mat-icon>
            <h5 class="state-title">Failed to create the connection.</h5>
            <p class="state-description">Check the connection details and permissions, then try again.</p>
            @if (failureDetails; as message) {
                <details class="failure-details">
                    <summary>Details</summary>
                    <p class="failure-message">{{ message }}</p>
                </details>
            }
        </div>
    } @else if (connectionResult(); as result) {
        <div class="state-panel state-panel-success">
            <mat-icon class="state-icon" aria-label="Connection created">check_circle</mat-icon>
            <p class="state-description">Your connection is ready to use.</p>
            <dl class="connection-summary">
                <div>
                    <dt>Connection name</dt>
                    <dd>{{ result.alias }}</dd>
                </div>
                <div>
                    <dt>Business domain</dt>
                    <dd>{{ result.businessDomainName }}</dd>
                </div>
                <div>
                    <dt>Host or path</dt>
                    <dd class="breakable-value">{{ result.host }}</dd>
                </div>
                @if (result.catalog) {
                    <div>
                        <dt>Catalog</dt>
                        <dd>{{ result.catalog }}</dd>
                    </div>
                }
                <div>
                    <dt>Connection type</dt>
                    <dd>{{ result.connectionType }}</dd>
                </div>
                <div>
                    <dt>Authentication</dt>
                    <dd>{{ result.authType }}</dd>
                </div>
            </dl>
        </div>
    }
</div>
<div class="modal-footer">
    @if (provisioningState() === 'Pending') {
        <button mat-button type="button" (click)="closeWhilePending()">Close</button>
    } @else {
        @if (provisioningState() === 'Failed') {
            <button
                mat-flat-button
                color="primary"
                type="button"
                class="footer-start-action"
                (click)="retryProvisioning()"
            >
                Retry
            </button>
        }
        <button mat-button type="button" (click)="close()">Close</button>
    }
</div>
